/**
 * Debug 调试辅助日志
 */
export default class Debug {
  log(...e) {
    this._write("log", ...e);
  }

  error(...err) {
    this._write("error", ...err);
  }

  warn(...e) {
    this._write("warn", ...e);
  }

  _write(type, ...data) {
    const isDevelopment = process.env.VUE_APP_STATIC_NODE_ENV !== "production";
    const text = JSON.stringify(data);
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hour = now.getHours();
    const minute = now.getMinutes();
    const second = now.getSeconds();
    const time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    const message = `${time} [${type}] ${text}\n`;
    if (isDevelopment) {
      console.log(message);
    }
  }
}
